export const photoViewerNoticeDataName = 'notice-photo-wrapper'
